import {PlayClass} from "../../models/class-structure/generic/PlayClass";
import {ClassStep} from "../../models/class-structure/generic/ClassStep";
import {EndStepAction, PreviousStepAction} from "../../models/types/ClassTypes";

import {AbstractPlayClassController} from "./AbstractPlayClassController";

export class MultipleClassController extends AbstractPlayClassController {

  /* Class Content */
  public readonly orderedClassControllers: AbstractPlayClassController[];

  /* Status */
  public currentClassIndex: number;

  constructor(playClass: PlayClass, orderedClassControllers: AbstractPlayClassController[], hasDemo: boolean = false, currentClassIndex: number = 0) {
    super(playClass, hasDemo)

    this.orderedClassControllers = orderedClassControllers;
    this.currentClassIndex = currentClassIndex;

    this.isFinished = (this.orderedClassControllers.length - 1) === currentClassIndex && this.orderedClassControllers[currentClassIndex].isFinished
  }

  private get activeClassController(): AbstractPlayClassController {
    return this.orderedClassControllers[this.currentClassIndex];
  }

  /* Play Class Controller Interface */

  public get activeClass(): PlayClass {
    return this.activeClassController.activeClass;
  }
  public get activeStep(): ClassStep {
    if (this.shouldDisplayDemo) {
      return this.playClass.getDemoStep(this.isClassStarted());
    }
    return this.activeClassController.activeStep;
  }
  public get previousStep(): ClassStep|null {
    if (this.activeClassController.previousStep) {
      return this.activeClassController.previousStep;
    }
    if (this.currentClassIndex > 0) {
      return this.orderedClassControllers[this.currentClassIndex - 1].activeStep;
    }
    return null;
  }

  public loadNextStep() : EndStepAction {
    if (this.shouldDisplayDemo) {
      this.isDemoCompleted = true;
      return "NEXT_STEP";
    }

    const childEndStepAction = this.activeClassController.loadNextStep();
    const endStepAction = this.getEndStepActionBasedOnChildEndStepAction(childEndStepAction);

    switch (endStepAction) {
      case "END_CLASS":
        this.isFinished = true;
        break;
      case "NEXT_CLASS":
        this.currentClassIndex++;
        if(this.orderedClassControllers[this.currentClassIndex].playClass.progress.isFinished
          && this.orderedClassControllers.length >= this.currentClassIndex + 1
          && !this.orderedClassControllers[this.currentClassIndex+1].playClass.progress.isFinished){
          this.currentClassIndex++
        }
        break;
      case "NEXT_STEP":
        break;
    }
    return endStepAction;
  }
  private getEndStepActionBasedOnChildEndStepAction(endStepAction: EndStepAction) {
    switch (endStepAction) {
      case "NEXT_STEP":
        return "NEXT_STEP";

      case "NEXT_CLASS":
        return "NEXT_CLASS";

      case "END_CLASS":
        if (this.currentClassIndex === this.orderedClassControllers.length - 1) {  // Is on last Class
          return "END_CLASS";
        }
        else {
          return "NEXT_CLASS"
        }
    }
  }

  public loadPreviousStep(): PreviousStepAction {
    const previousStepAction = this.activeClassController.loadPreviousStep();

    if (previousStepAction === "CLASS_START") {
      if (this.currentClassIndex > 0) {
        this.currentClassIndex--;
        return "PREVIOUS_CLASS";
      }
      else {
        // TODO: Handle Demo ?
        return "CLASS_START";
      }
    }

    return previousStepAction;
  }
  public setClassAndStep(classId: number, stepId: number|'demo') {
    this.isDemoCompleted = true; // Because demo is out of class & steps workflow
    if (stepId === 'demo') {
      this.isDemoCompleted = false;
    }
    else {
      this.currentClassIndex = this.orderedClasses.findIndex((playClass) => playClass.id === classId);
      this.activeClassController.setClassAndStep(classId, stepId);
    }
  }
}
